<div class="flex overflow_hidden relative full_width" [class]="wrapper_classes"
    [ngStyle]="{'max-width': width, 'width': width}"
    [ngClass]="{hover: hoverOn, with_hover: withHover}"
    [style]="wrapper_style | safeCss">
    <div class="aspect_ratio" [style.padding-top.%]="aspect_ratio"></div>
    <img [src]="img_src" [style.objectFit]="object_fit" onerror="this.onerror=null;this.src='/assets/img/image-not-found.svg';" [alt]="alt">
</div>